import AddIcon from "@mui/icons-material/Add";

import { usePopupState } from "@/shared/hooks";

import { RobotoIconButton } from "../RobotoIconButton";
import { RobotoTooltip } from "../RobotoTooltip";

import { CreateDatasetPopover } from "./CreateDatasetPopover";

export function CreateDatasetButton() {
  const popup = usePopupState();
  return (
    <>
      <RobotoTooltip title={"New Dataset"}>
        <span>
          <RobotoIconButton
            onClick={(e) => popup.open({ anchorEl: e.currentTarget })}
            eventName={"CreateDatasetClicked"}
            eventProperties={{ source: "navigationBar" }}
          >
            <AddIcon sx={{ width: 20, height: 20 }} />
          </RobotoIconButton>
        </span>
      </RobotoTooltip>
      <CreateDatasetPopover anchorEl={popup.anchor} handleClose={popup.close} />
    </>
  );
}
